import React from 'react'
import PropTypes from 'prop-types'
import TextareaResize from '#components/a/form/TextareaResize'
import QuestionDescription from './QuestionDescription'
import {withAnswer} from '#components/HOC/withAnswerHOC'

export class QuestionMultipleFreitext extends React.Component {
  onChangeText = (questionOrder, event) => {
    const updatedAnswer = this.getCurrentAnswer()
    updatedAnswer.text[questionOrder] = event.target.value
    this.props.updateAnswer(updatedAnswer)
    this.props.setHasUnsavedChanges(true)
  }

  onBlur = async () => {
    await this.props.saveAnswer()
    this.props.setHasUnsavedChanges(false)
  }

  getCurrentAnswer() {
    const defaultAnswer = {text: {}}
    return this.props.currentAnswer && this.props.currentAnswer.text ? this.props.currentAnswer : defaultAnswer
  }

  render() {
    const answer = this.getCurrentAnswer()
    const {question, isReadOnly} = this.props
    return (
      <>
        {this.props.children}
        <QuestionDescription question={question} />
        {question.content.map(q => (
          <TextareaResize
            modifier="multipleInput"
            key={q.order}
            value={answer.text[q.order] || ''}
            onChangeHandle={e => this.onChangeText(q.order, e)}
            onBlurHandle={this.onBlur}
            labelText={q.label}
            disabled={isReadOnly}
          />
        ))}
      </>
    )
  }
}

QuestionMultipleFreitext.propTypes = {
  updateAnswer: PropTypes.func.isRequired,
  saveAnswer: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  currentAnswer: PropTypes.object,
  question: PropTypes.object,
  setHasUnsavedChanges: PropTypes.func.isRequired,
  children: PropTypes.node,
}

export default withAnswer(QuestionMultipleFreitext)
